import { useRef as a, useCallback as o, useEffect as f } from "react";
function l(s, c) {
  const e = a(null), r = o(() => {
    e.current && e.current.disconnect();
  }, []), u = o((t) => {
    e.current && e.current.observe(t);
  }, []);
  return f(() => ("IntersectionObserver" in window && (e.current = new IntersectionObserver(async (t) => {
    for (let n = 0; n < t.length; n++) {
      const i = t[n];
      i.isIntersecting && i.target.matches(s) && (await c(), r());
    }
  })), () => {
    r();
  }), [s, c, r]), {
    observe: u,
    stopObserving: r
  };
}
export {
  l as default
};
//# sourceMappingURL=useIntersectionObserver.es.js.map
